import { render, staticRenderFns } from "./category-props.vue?vue&type=template&id=1a3104eb&scoped=true&"
import script from "./category-props.vue?vue&type=script&lang=js&"
export * from "./category-props.vue?vue&type=script&lang=js&"
import style0 from "./category-props.vue?vue&type=style&index=0&id=1a3104eb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3104eb",
  null
  
)

export default component.exports